import { useCallback, useState } from "react";
import storageService from "../services/storageService";

const useLocalStorage = (key, defaultValue) => {
  // 1. Helper to read from service (No JSON.parse needed)
  const readValue = useCallback(() => {
    try {
      const value = storageService.get(key);

      // Check if value exists (assuming service returns null/undefined if missing)
      if (value !== null && value !== undefined) {
        return value;
      } else {
        // Initialize storage with default (No JSON.stringify needed)
        storageService.set(key, defaultValue);
        return defaultValue;
      }
    } catch (error) {
      console.warn(`Error reading localStorage key "${key}":`, error);
      return defaultValue;
    }
  }, [key, defaultValue]);

  const [storedValue, setStoredValue] = useState(readValue);

  // // 2. Update state if the 'key' changes (Critical for switching views/tables)
  // useEffect(() => {
  //   setStoredValue(readValue());
  // }, []);

  // 3. Setter Function
  const setValue = (valueOrFn) => {
    try {
      setStoredValue((prevValue) => {
        // Handle functional updates: setValue(prev => prev + 1)
        const valueToStore = valueOrFn instanceof Function ? valueOrFn(prevValue) : valueOrFn;

        // Save to Service (No JSON.stringify needed)
        storageService.set(key, valueToStore);

        return valueToStore;
      });
    } catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error);
    }
  };

  const removeKey = () => {
    storageService.remove(key);
    setStoredValue(defaultValue);
  };

  return [storedValue, setValue, removeKey];
};

export default useLocalStorage;
